import './Privacy.css';
import loadable from '@loadable/component';

export default loadable(() => {
  return import('./Privacy.jsx');
});
